import { Button } from '../../../../components/ui/button'
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
  AlertDialogTrigger,
} from '../../../../components/ui/alert-dialog'
import { useRemoveSellerController } from './useRemoveSellerController'

export const RemoveSeller = ({ id }: { id: string }) => {
  const { handleRemoveSeller, isPending } = useRemoveSellerController()

  return (
    <div>
      <AlertDialog>
        <AlertDialogTrigger
          asChild
          onClick={(event) => event.stopPropagation()}
        >
          <i className="fa-solid fa-user-minus text-lg text-error"></i>
        </AlertDialogTrigger>
        <AlertDialogContent className="w-96">
          <form
            onClick={(event) => event.stopPropagation()}
            onSubmit={(event) => handleRemoveSeller(event, id)}
          >
            <AlertDialogHeader>
              <AlertDialogTitle>
                Você quer realmente remover esse usuário?
              </AlertDialogTitle>
            </AlertDialogHeader>
            <AlertDialogFooter className="flex items-center">
              <AlertDialogCancel>Cancelar</AlertDialogCancel>
              <AlertDialogAction asChild>
                <Button
                  type="submit"
                  disabled={isPending}
                  className="my-4 bg-primary font-bold text-white01 hover:bg-primary hover:brightness-150"
                >
                  Remover
                </Button>
              </AlertDialogAction>
            </AlertDialogFooter>
          </form>
        </AlertDialogContent>
      </AlertDialog>
    </div>
  )
}
